import { appInfoSliceName } from '../slices/appInfo/constants';
import { AppInfoState } from '../slices/appInfo/state';
import { licenseSliceName } from '../slices/license/constants';
import { LicenseState } from '../slices/license/state';
import { alertSliceName } from '../slices/alerts/constants';
import { AlertState } from '../slices/alerts/state';
import { toastsSliceName } from '../slices/toasts/constants';
import { ToastsState } from '../slices/toasts/state';

export const RootState = {
  [appInfoSliceName]: AppInfoState,
  [licenseSliceName]: LicenseState,
  [alertSliceName]: AlertState,
  [toastsSliceName]: ToastsState,
};
